import { useTranslation } from 'react-i18next';

const BenefitsSection = () => {
  const { t } = useTranslation('pharmacies');

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('benefits.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('benefits.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {t('benefits.items', { returnObjects: true }).map((benefit: any, index: number) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`text-2xl text-green-600 ${
                  index === 0 ? 'ri-shield-check-line' :
                  index === 1 ? 'ri-book-open-line' :
                  index === 2 ? 'ri-bar-chart-box-line' :
                  'ri-file-shield-2-line'
                }`}></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;